/**
 * Mobile bottom navigation (PHASE1 §7.1) — visible <md. Shows the primary nav
 * items plus a "Mehr" button opening the overflow sheet.
 */
import { useState } from 'react';
import { NavLink } from 'react-router';
import { MoreHorizontal } from 'lucide-react';
import { navItemsFor, PRIMARY_NAV_COUNT } from './AppShell.tsx';
import { MoreSheet } from './MoreSheet.tsx';
import { useCurrentUser } from '../../lib/hooks/useCurrentUser.ts';

export function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const items = navItemsFor(useCurrentUser());
  const primary = items.slice(0, PRIMARY_NAV_COUNT);
  const overflow = items.slice(PRIMARY_NAV_COUNT);

  const itemClass = (isActive: boolean) =>
    `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors duration-150 ${
      isActive ? 'text-sky-600 dark:text-sky-400' : 'text-slate-400 dark:text-slate-500'
    }`;

  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-slate-100 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden dark:border-slate-800/70 dark:bg-slate-950/95">
        {primary.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => itemClass(isActive)}>
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
        {overflow.length > 0 ? (
          <button
            type="button"
            onClick={() => setMoreOpen(true)}
            className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium text-slate-400 transition-colors duration-150 dark:text-slate-500"
          >
            <MoreHorizontal className="h-5 w-5" />
            Mehr
          </button>
        ) : null}
      </nav>

      <MoreSheet open={moreOpen} onOpenChange={setMoreOpen} items={overflow} />
    </>
  );
}
